import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, Subscription } from 'rxjs';
import { from } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Router, NavigationEnd, NavigationSkipped } from '@angular/router';
import { Hub } from 'aws-amplify/utils';
import { fetchAuthSession, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { IUser } from '../../models/IUser';
import { UserActions } from 'src/app/store/user.actions';
import { Store } from '@ngxs/store';
import { post } from 'aws-amplify/api';
// const axios = require('axios').default;
import axios, { AxiosHeaders } from 'axios';
@Injectable({
    providedIn: 'root'
})
export class AuthenticationService implements OnDestroy {
    private login: boolean = false;
    private roles: Array<string> = [];
    paramObsRoute: Subscription;

    constructor(private route: Router, private zone: NgZone, private store: Store) {
        this.start();
        this.requestInterceptors();
        if (window.location.href == `${environment.aws.oauth.redirectUrl}/`
            && !window?.location?.href.split('code=')[1]
            && !localStorage.hasOwnProperty(`CognitoIdentityServiceProvider.${environment.aws.userPoolWebClientId}.LastAuthUser`)) {
            this.socialLogin('datapower');
        }
        Hub.listen('auth', ({ payload }) => {
            switch (payload.event) {
                //  v6 successful sign-in
                case 'signedIn':
                case 'signInWithRedirect':
                    this.login = true;
                    this.handleUserRedirect();
                    break;
                //  v6 sign-out
                case 'signedOut':
                    this.login = false;
                    this.roles = [];
                    this.route.navigate(['logout']);
                    break;
                // v6 failures
                case 'signInWithRedirect_failure':
                case 'tokenRefresh_failure':
                    // case 'signedOut_failure':
                    this.login = false;
                    this.roles = [];
                    this.route.navigate(['login']);
                    break;
                default:
                    break;
            }
        });
        this.handleUserRedirect();
    }

    // public socialLogin(provider: string): void {
    //     Auth.federatedSignIn(<any>{
    //         provider
    //     })
    //         .catch((error) => {
    //             this.signOut();
    //         });
    // }

    public socialLogin(provider: string): void {
        signInWithRedirect({ provider: { custom: provider } })
            .catch(() => {
                this.signOut();
            });
    }
    handleUserAuth(): void {
        if (this.login) {
            this.handleUserRedirect();
        }
    }

    getUserRoles(): Array<String> {
        return this.roles;
    }

    // getUserEmail(): Observable<String> {
    //     return from(
    //         Auth.currentAuthenticatedUser().then(
    //             user => {
    //                 return (user.signInUserSession) ? user.signInUserSession.idToken.payload["email"] : user.email;
    //             }
    //         )
    //     );
    // }

    getUserEmail(): Observable<string> {
        return from(
            (async () => {
                const session = await fetchAuthSession();
                if(!session.tokens){
                  this.route.navigate(['/login']);
                }
                const email = session.tokens?.idToken?.payload?.['email'] as string | undefined;
                return email ?? '';
            })()
        );
    }

    private setUserState(): void {
        this.getUser().pipe(take(1)).subscribe(user => {
            this.store.dispatch(new UserActions.SetUser(user));
        });
    }

    // getUser(): Observable<IUser> {
    //     return this.getUserEmail().pipe(
    //         switchMap((email) => {
    //             const payload = {
    //                 email
    //             };
    //             return from(API.post('portal', 'persons', { body: payload }));
    //         })
    //     );
    // }

    getUser(): Observable<IUser> {
        return this.getUserEmail().pipe(
            switchMap((email) => {
                const payload = { email };
                const op = post({
                    apiName: 'portal',
                    path: 'persons',
                    options: { body: payload as Record<string, any> },
                });
                return from(op.response.then(async (r) => (await r.body.json()) as unknown as IUser));
            })
        );
    }

    signOut(): void {
        signOut().catch(() => {
            // ignore
        });
    }

    // private handleUserRedirect(): void {
    //     Auth.currentAuthenticatedUser().then(
    //         user => {
    //             this.setUserState();
    //             if (user.signInUserSession) {
    //                 const idpRole = user.signInUserSession?.idToken?.payload["custom:Role"];
    //                 const cognitoGroup = user.signInUserSession?.idToken?.payload["cognito:groups"];

    //                 this.roles = idpRole ? idpRole : cognitoGroup;
    //             } else {
    //                 this.roles = [localStorage.getItem("role")];
    //             }
    //             // aws-amplify handles this auth promise outside of the angular zone
    //             // which prevents the router-outlet from rendering the component we
    //             // want to navigate to. So we explicitly reenter the angular zone
    //             this.routeObs();
    //             let routeNav = sessionStorage?.getItem('previousUrl')?.substring(1);

    //             this.zone.run(() => {
    //                 if (routeNav) {
    //                     this.route.navigate([`${decodeURIComponent(routeNav)}`]);
    //                 }
    //                 else {
    //                     if (this.roles.includes('participant')) {
    //                         this.route.navigate(['journey/home']);
    //                     } else if (this.roles.includes('facilitator')) {
    //                         this.route.navigate(['admin/programs-external']);
    //                     } else if (this.roles.includes('flightReport')) {
    //                         this.route.navigate(['admin/reports/arrival']);
    //                     } else if (this.roles.includes('admin')) {
    //                         this.route.navigate(['admin']);
    //                     } else {
    //                         this.route.navigate(['error']);
    //                     }
    //                 }
    //             });
    //         }
    //     )
    //         .catch((error) => {
    //             console.log('Something went wrong during handleUserRedirect', JSON.stringify(error));
    //         });
    // }

    private handleUserRedirect(): void {
        fetchAuthSession()
            .then((session) => {
                // keep your existing store update
                this.setUserState();
                const payload = session.tokens?.idToken?.payload ?? {};
                const idpRole = payload['custom:Role'] as string | undefined;
                // Cognito groups can be string[] or string depending on token/TS
                const cognitoGroupsRaw = payload['cognito:groups'] as string[] | string | undefined;
                const cognitoGroups: string[] = Array.isArray(cognitoGroupsRaw)
                    ? cognitoGroupsRaw
                    : cognitoGroupsRaw
                        ? [cognitoGroupsRaw]
                        : [];
                if (idpRole) {
                    this.roles = [idpRole];
                } else if (cognitoGroups.length) {
                    this.roles = cognitoGroups;
                } else {
                    const stored = localStorage.getItem('role');
                    this.roles = stored ? [stored] : [];
                }
                const routeNav = sessionStorage?.getItem('previousUrl')?.substring(1);
                // re-enter Angular zone before routing (same as your comment)
                this.zone.run(() => {
                    if (routeNav) {
                        this.route.navigate([`${decodeURIComponent(routeNav)}`]);
                        return;
                    }
                    if (this.roles.includes('participant')) {
                        this.route.navigate(['/journey/home']);
                    } else if (this.roles.includes('facilitator')) {
                        this.route.navigate(['/admin/programs-external']);
                    } else if (this.roles.includes('FlightReport')) {
                        this.route.navigate(['/admin/reports/arrival']);
                    } else if (this.roles.includes('admin')) {
                        this.route.navigate(['/admin']);
                    } else {
                        this.route.navigate(['error']);
                    }
                });
            })
            .catch((error) => {
                // console.log(
                //     'Something went wrong during handleUserRedirect: ',
                //     JSON.stringify(error)
                // );
                this.zone.run(() => {
                    this.route.navigate(['error/401']);
                });
            });
    }

    // private handleUserLogin() {
    //     const resp = window.location.search.split('SAMLResponse=')[1];
    //     if (resp != undefined) {
    //         const token = resp.replace(/%2B/g, '+').replace(/%3D/g, '');
    //         const parser = new DOMParser();
    //         const xmlDoc = parser.parseFromString(atob(token), "text/xml");
    //         const domain = environment.aws.samlProviderId;
    //         const expiresAt = 3600 * 1000 + new Date().getTime(); // 1 hour expire time for session
    //         // localStorage.setItem("expiresAt", expiresAt.toString());
    //         const user = {
    //             name: xmlDoc.querySelector("NameID").textContent,
    //             email: xmlDoc.querySelector("Attribute[Name='emailAddress'] > AttributeValue").textContent
    //         };
    //         localStorage.setItem("role", xmlDoc.querySelector("Attribute[Name='Role'] > AttributeValue").textContent);

    //         Auth.federatedSignIn(domain, { token, "expires_at": expiresAt }, user)
    //             .catch((error) => {
    //                 console.log('Something went wrong while SSO login. Signing out!', JSON.stringify(error));
    //                 this.signOut();
    //             });
    //     } else {
    //         this.route.navigate(['login']);
    //     }
    // }

    // private requestInterceptors() {
    //     axios.interceptors.request.use(function (config) {
    //         if (!config?.headers?.Authorization || !config?.headers['X-Amz-Security-Token']) {
    //             console.log('Token does not exist. Logging out');
    //             Auth.signOut();
    //             this.route.navigate(['logout']);
    //         }
    //         return config;
    //     }, function (error) {
    //         // Do something with request error
    //         return Promise.reject(error);
    //     });
    // }

    // private requestInterceptors(): void {
    //     axios.interceptors.request.use(
    //         async (config) => {
    //             try {
    //                 const session = await fetchAuthSession();
    //                 const token = session.tokens?.accessToken?.toString();
    //                 if (!token) {
    //                     console.log('Token does not exist. Logging out. Navigating out');
    //                     await signOut();
    //                     this.route.navigate(['logout']);
    //                     return config;
    //                 }

    //                 config.headers = config.headers ?? {};
    //                 (config.headers as any).Authorization = token;
    //                 return config;
    //             } catch (e) {
    //                 console.log('Token check failed. Logging out.');
    //                 await signOut();
    //                 this.route.navigate(['logout']);
    //                 return config;
    //             }
    //         },
    //         (error) => Promise.reject(error)
    //     );
    // }

    private requestInterceptors(): void {
        axios.interceptors.request.use(
            async (config) => {
                try {
                    const session = await fetchAuthSession();
                    const token = session.tokens?.accessToken?.toString();
                     if (!token) {
                        // console.log('Token does not exist. Logging out. Navigating out');
                        await signOut();
                        this.route.navigate(['logout']);
                        return config;
                    }

                         config.headers = config.headers ?? new AxiosHeaders();
                        (config.headers as AxiosHeaders).set('Authorization', token);
                    return config;
                } catch (e) {
                    // console.log('Token check failed. Logging out.');
                    await signOut();
                    this.route.navigate(['logout']);
                    return config;
                }
            },
            (error) => Promise.reject(error)
        );
    }

    // Sign Out all tabs/windows when logged out of any tab.
    public signIn = () => {
        this.login = true;
        this.route.navigate([''])
    }

    public logOut = () => {
        this.login = false;
        this.route.navigate(['logout']);
    }

    private start(): void {
        window.addEventListener("storage", this.storageEventListener.bind(this));
    }

    private storageEventListener(event: StorageEvent) {
        if (event.storageArea == localStorage) {
            if (event?.key && event.key == 'logout-event') {
                this.logOut()
            }
        }
    }

    private stop(): void {
        window.removeEventListener("storage", this.storageEventListener.bind(this));
    }

    public routeObs() {
        this.paramObsRoute = this.route.events.subscribe((event) => {
            if ((event instanceof NavigationEnd || event instanceof NavigationSkipped)
                && event.url !== '/logout' && !event.url.includes('/error')) {
                window.sessionStorage.setItem('previousUrl', event.url);
            }
        });
    }

    ngOnDestroy() {
        this.stop()
        this.paramObsRoute.unsubscribe();
    }
}
